import { render, staticRenderFns } from "./not-found.scene.vue?vue&type=template&id=42b3595e&scoped=true"
var script = {}
import style0 from "./not-found.scene.scss?vue&type=style&index=0&id=42b3595e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3595e",
  null
  
)

export default component.exports